<template>
  <div class="container">
    <div v-if="dataReady" class="questionnaireList">
      <div class="top-banner">
        <img class="top-banner__image" src="../../assets/images/patrolman_banner@2x.png">
      </div>
      <div class="questionnaireHeader">
        <div class="title">活动说明</div>
        <div class="summary patrolman" v-html="question.summary" ref="summary">
        </div>
      </div>
      <div class="questionnaireBody">
        <div class="question-list">
          <van-checkbox-group>
            <van-cell-group >
              <van-cell v-for="option in question.wjStatisticsBeanList" :key="option.id" @click="seemore(option.content)">
                <template #title>
                  <div class="radio_content">
                    <div class="left-side">
                      <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                    </div>
                    <div class="label">
                      <div class="label_val" v-html="option.content"></div>
                      <span class="more" @click.stop="seemore(option.content)">...「查看详情」</span>
                    </div>
                  </div>
                </template>
                <template #right-icon>
                  <div class="votes">{{option.num}}票</div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </div>
      <div class="fixed-footer">
        <div @click="toVote" class="option-button">继续投票</div>
      </div>
      <!-- <div class="questionnaireFooter" v-if="question.questionList && question.questionList.length > 0">
        <van-button v-if="question.mode === '投票'" class="btn rankinglistBtn" @click="goRanking">查看排行榜</van-button>
        <van-button :class="question.isresult ? 'btn isresult' : 'btn'" color="#DB2D2D" :disabled="question.isresult" @click="submit">{{btnText}}</van-button>
      </div> -->
      <van-popup v-model="show">
        <div class="popup-close"><van-icon name="cross" @click="closePopup" /></div>
        <div class="questionnaire_popup">
          <!-- <div class="questionnaire_popup_header">
            <van-icon name="cross" @click="closePopup" />
          </div> -->
          <div class="questionnaire_popup_body" v-html="nowShow"></div>
        </div>
      </van-popup>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  import $ from 'jquery'
  export default {
    name: 'patrolmanRanking',
    data () {
      return {
        id: 11,
        dataReady: true,
        show: false,
        nowShow: '',
        question: {}
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.QUESTIONNAIRERESULTLIST, {
        questionnaireid: this.id
      }).then(res => {
        // console.log(res)
        this.question = res.data
        this.dataReady = true
        this.$nextTick(function () {
          $(".label").each(function(index, el) {
            if ($(el).height() > 100) {
              $(el).height(100)
              $(el).find('.more').show()
            }
          })
          $('.label_val').each(function(index, el) {
            $(el).find('p:first-child').css({'color':'#006840', 'font-weight': 'bold'})
          })
          if (u.indexOf('MicroMessenger') > -1) {
            var summary = this.$refs.summary ? this.$refs.summary.innerText.trim().replace(/\ +/g,"").replace(/[\r\n]/g,"").replace(/\s/g,"").substr(0, 50) : '广东科技报'
            this.$fetch.get(API.GETWECHATINVOKESIGN, {
              url: window.location.href
            }).then(response => {
              let data = response.data
              wx.config({
                debug: false,
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function(){
                wx.updateAppMessageShareData({
                  title: '守森林、护大海，这些平凡英雄值得您的一票',
                  desc: '动动手指，为他们加油吧！',
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.updateTimelineShareData({
                  title: '守森林、护大海，这些平凡英雄值得您的一票',
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.onMenuShareWeibo({
                  title: '守森林、护大海，这些平凡英雄值得您的一票',
                  desc: '动动手指，为他们加油吧！',
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  },
                  cancel: function(){
                    console.log('分享取消')
                  }
                })
              })
            })
          }
        })
      }).catch(error => {
        console.log(error)
      })
    },
    methods: {
      seemore (val) {
        this.nowShow = val
        this.show = true
        this.$nextTick(() => {
          $('.questionnaire_popup_body').find('p:first-child').css({'color':'#006840', 'font-weight': 'bold', 'font-size': '16px', 'margin-bottom': '5px'})
        })
        return false
      },
      toVote() {
        this.viewVote = false
        this.$router.replace({
          path: 'patrolman'
        })
      },
      closePopup () {
        this.show = false
      },
      goBack () {
        this.$router.push({
          path: '/questionnaire/patrolman'
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .questionnaireList
    background #effcd1 url('../../assets/images/patrolman_bg@2x.jpg') no-repeat
    background-size 100%
    background-position-y 210px
    padding-bottom 56px
    min-height 100%
  .top-banner__image
    display block
    width 100%
  .questionnaireHeader
    margin-top -55px
    border-bottom none
    .title
      color #006740
      text-align center
    .summary
      font-size 15px
      color #006740
  .questionnaireBody
    .question-list
      border-bottom none
      .question-title
        color #006740
      .van-cell-group, .van-cell
        overflow auto
        background transparent url('../../assets/images/flower@2x.png') left bottom
        background-repeat repeat-x
      .van-checkbox-group .van-cell-group .van-cell:active
        background-color rgba(180, 206, 152, 0.3)
      .van-radio-group .van-cell-group .van-cell:active
        background-color rgba(180, 206, 152, 0.3)
      .van-cell::after
        display none
      .van-cell > .votes
        font-size 15px
        color #DB2D2D 
        margin-left 15px
        display flex
        align-items center
      .radio_content .label .more
        background-image linear-gradient(to right, rgba(255,255,255,0.0), #f1fcd4 18px) !important
      .left-side
        > .votes
          text-align center
          color #DB2D2D
          margin-right 15px
          margin-top 5px
  .van-radio-group .van-radio[aria-checked=true] .van-radio__icon--checked .van-icon
    background-color transparent
    color #006840
  .fixed-footer
    position fixed
    left 0
    bottom 0
    width 100%
    display flex
    .option-button
      flex 1
      display flex
      justify-content center
      align-items center
      font-size 15px
      color #fff
      height 56px
      &:first-child
        background-color #2CA8F5
      &:last-child
        background-color #006840
      &:active
        filter brightness(0.9)
  .van-popup
    border-radius 8px
  .questionnaire_popup
    width 50vh
    max-height 80vh
    overflow-y scroll
  .popup-close 
    height 40px
    width 100%
    padding 0 15px
    text-align right
    -webkit-box-sizing border-box
    box-sizing border-box
    border-1px()
    .van-icon-cross
      color #666
      font-size 22px
      line-height 40px
  .radio_content .logo
    border 3px solid #a9e0f5
    border-radius 5px
    box-sizing border-box
  .questionnaireBody .question-list .van-checkbox-group .van-cell-group .van-cell
    padding 18px 15px 44px
</style>